'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _branch = require('recompose/branch');

var _branch2 = _interopRequireDefault(_branch);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  autoFocus: _propTypes.bool
}), (0, _branch2.default)(function (_ref) {
  var autoFocus = _ref.autoFocus;
  return !!autoFocus;
}, function (BaseComponent) {
  var ListenLoadDone = function (_React$Component) {
    _inherits(ListenLoadDone, _React$Component);

    function ListenLoadDone(props, context) {
      _classCallCheck(this, ListenLoadDone);

      var _this = _possibleConstructorReturn(this, (ListenLoadDone.__proto__ || Object.getPrototypeOf(ListenLoadDone)).call(this, props, context));

      _this.element = null;

      _this.inputRef = _this.inputRef.bind(_this);
      _this.listener = _this.listener.bind(_this);
      return _this;
    }

    _createClass(ListenLoadDone, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.context.emitter.addListener('loadDone', this.listener);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context.emitter.removeListener('loadDone', this.listener);
      }
    }, {
      key: 'inputRef',
      value: function inputRef(element) {
        this.element = element;
      }
    }, {
      key: 'listener',
      value: function listener() {
        this.element.focus();
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(BaseComponent, _extends({}, this.props, { inputRef: this.inputRef }));
      }
    }]);

    return ListenLoadDone;
  }(_react2.default.Component);

  ListenLoadDone.contextTypes = { emitter: _propTypes.object.isRequired };

  return ListenLoadDone;
}), (0, _exposeProps2.default)(['inputRef']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'autoFocusWhenLoaded');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/autoFocusWhenLoaded.js
// module id = 1645
// module chunks = 0